



const state = {
    userInfo: null,
}

//申明同步方法
const mutations = {
    //存数据
    getUserInfo(state,obj){
        state[obj.typeName] = obj.typeNum
    },
}

//申明异步方法
const actions = {

}

export default {
    state,
    mutations,
    actions
}